export const validateField = (name, value) => {
  switch (name) {
    case 'email':
      if (!value) {
        return "Обов'язкове поле";
      } else if (!/\S+@\S+\.\S+/.test(value)) {
        return 'Недійсний формат';
      }
      break;

    case 'password':
      if (!value) {
        return "Обов'язкове поле";
      } else if (value.length < 6) {
        return 'Не менше 6 символів';
      }
      break;

    case 'name':
      if (!value) {
        return "Обов'язкове поле";
      } else if (value.length < 2) {
        return 'Два або більше символів';
      }
      break;

    case 'address':
      if (!value.trim()) return 'Обов’язкове поле';
      break;

    case 'clients':
      if (!value.length || value.some((client) => !client.trim())) {
        return 'Обов’язкове поле';
      }
      break;

    case 'payments':
      if (!value.length || value.some((client) => !client.trim())) {
        return 'Обов’язкове поле';
      }
      break;

    case 'service':
      if (!value.trim()) return 'Обов’язкове поле';
      break;

    default:
      break;
  }
  return null;
};
